import { atomWithStorage }                from "jotai/utils";
import { atom, useAtomValue, useSetAtom } from "jotai";

export const userLoggedInAtom = atomWithStorage ( "user-logged-in", false );
export const userProfileDataAtom = atomWithStorage ( "user-profile-data", null );

export const useSetLoggedIn = () => {
	return useSetAtom ( userLoggedInAtom );
};

export const useGetLoggedIn = () => {
	return useAtomValue ( userLoggedInAtom );
};

export const useSetProfileData = () => {
	return useSetAtom ( userProfileDataAtom );
};

export const useGetProfileData = () => {
	return useAtomValue ( userProfileDataAtom );
};

export const userProfileIdAtom = atom ( get => get ( userProfileDataAtom )?.id );

export const useGetProfileId = () => {
	return useAtomValue ( userProfileIdAtom );
};
